var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
import { useSafeRunMutation } from 'utils/mutations';
// TEAM_DELETE_PERMISSION
export var mutation = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation TeamDeletePermission($id: ID!, $permission: TEAM_PERMISSION!) {\n    teamDeletePermission(id: $id, permission: $permission) {\n      id\n      permissions\n    }\n  }\n"], ["\n  mutation TeamDeletePermission($id: ID!, $permission: TEAM_PERMISSION!) {\n    teamDeletePermission(id: $id, permission: $permission) {\n      id\n      permissions\n    }\n  }\n"])));
export default function useTeamDeletePermission() {
    var _a = useSafeRunMutation({
        mutation: mutation,
        responsePath: 'teamDeletePermission',
        successMessage: 'Team Permission Deleted'
    }), onMutate = _a.onMutate, loading = _a.loading;
    return { onMutate: onMutate, loading: loading };
}
var templateObject_1;
